var _defs, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack386({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.3,10.73V5H8.06a1.83,1.83,0,0,1,.85.17,1.25,1.25,0,0,1,.51.51,1.62,1.62,0,0,1,.2.78,1.52,1.52,0,0,1-.17.71A1.41,1.41,0,0,1,9,7.68a1.3,1.3,0,0,1,.65.5,1.57,1.57,0,0,1,.23.89,1.91,1.91,0,0,1-.21.91,1.31,1.31,0,0,1-.57.57,2.15,2.15,0,0,1-1,.18Zm.62-3.32h1a1.84,1.84,0,0,0,.56-.06.67.67,0,0,0,.38-.27A1,1,0,0,0,9,6.55,1,1,0,0,0,8.89,6a.69.69,0,0,0-.32-.29,2.31,2.31,0,0,0-.71-.07H6.92Zm0,2.64H8.09A1.61,1.61,0,0,0,8.66,10a.78.78,0,0,0,.4-.33,1.08,1.08,0,0,0,.14-.59,1.07,1.07,0,0,0-.13-.55.86.86,0,0,0-.36-.32A1.72,1.72,0,0,0,8,8.08H6.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack386);
export default __webpack_public_path__ + "static/media/Symbol_pack_386.8d6a270e5e47fdaa869ceeb1747ef986.svg";
export { ForwardRef as ReactComponent };